module.exports = __webpack_public_path__ + "static/default-career-changers-mobile.155d9cb8.webp";